export enum BenefitEnrollmentStatusEnum {
    Invalid = "Invalid",
    CancellationPending = "CancellationPending",
    EnrollmentPending = "EnrollmentPending",
    Ongoing = "Ongoing"
}